module.exports = __webpack_public_path__ + "static/media/Eterno_Thumbnails.31.6af8a50f.png";